<template>
  <div class="redact_container">
    <!-- <el-button class="top_btn" @click="redactChange">变更</el-button> -->
    <!-- <span style="margin-left:20px;font-size:14px;color:#999;">无照片时，点击对应证件类型为新增，有照片时，点击照片即可修改</span> -->
    <div class="form_title">证件类型 <span>请上传格式为jpg、jpeg、png、pdf且大小不超过20M的图片或文件</span></div>
    <div class="papers_img">
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">机动车行驶证1</div>
          <div v-if="uploadData.carDrivingLicense1" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carDrivingLicense1.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carDrivingLicense1"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(1)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carDrivingLicense1 ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carDrivingLicense1 &&
                uploadData.carDrivingLicense1.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carDrivingLicense1"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carDrivingLicense1 ? true : false"
              @click="handlePictureCardPreview(1)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carDrivingLicense1 ||
                uploadData.carDrivingLicense1.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(1)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carDrivingLicense1 ? true : false"
              @click="handleRemove(1)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">机动车行驶证2</div>
          <div v-if="uploadData.carDrivingLicense2" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carDrivingLicense2.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carDrivingLicense2"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(2)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carDrivingLicense2 ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carDrivingLicense2 &&
                uploadData.carDrivingLicense2.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carDrivingLicense2"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carDrivingLicense2 ? true : false"
              @click="handlePictureCardPreview(2)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carDrivingLicense2 ||
                uploadData.carDrivingLicense2.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(2)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carDrivingLicense2 ? true : false"
              @click="handleRemove(2)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">道路运输证1</div>
          <div v-if="uploadData.roadTransportCertificate1" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.roadTransportCertificate1.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.roadTransportCertificate1"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(3)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.roadTransportCertificate1 ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.roadTransportCertificate1 &&
                uploadData.roadTransportCertificate1.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.roadTransportCertificate1"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.roadTransportCertificate1 ? true : false"
              @click="handlePictureCardPreview(3)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.roadTransportCertificate1 ||
                uploadData.roadTransportCertificate1.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(3)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.roadTransportCertificate1 ? true : false"
              @click="handleRemove(3)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">道路运输证2</div>
          <div v-if="uploadData.roadTransportCertificate2" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.roadTransportCertificate2.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.roadTransportCertificate2"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(4)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.roadTransportCertificate2 ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.roadTransportCertificate2 &&
                uploadData.roadTransportCertificate2.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.roadTransportCertificate2"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.roadTransportCertificate2 ? true : false"
              @click="handlePictureCardPreview(4)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.roadTransportCertificate2 ||
                uploadData.roadTransportCertificate2.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(4)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.roadTransportCertificate2 ? true : false"
              @click="handleRemove(4)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">机动车登记证书</div>
          <div v-if="uploadData.carRegistrationCertificate" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carRegistrationCertificate.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carRegistrationCertificate"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(5)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carRegistrationCertificate ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carRegistrationCertificate &&
                uploadData.carRegistrationCertificate.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carRegistrationCertificate"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carRegistrationCertificate ? true : false"
              @click="handlePictureCardPreview(5)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carRegistrationCertificate ||
                uploadData.carRegistrationCertificate.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(5)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carRegistrationCertificate ? true : false"
              @click="handleRemove(5)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">机动车整车出厂合格证</div>
          <div v-if="uploadData.carFactoryCertificate" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carFactoryCertificate.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carFactoryCertificate"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(6)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carFactoryCertificate ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carFactoryCertificate &&
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carFactoryCertificate"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handlePictureCardPreview(6)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carFactoryCertificate ||
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(6)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handleRemove(6)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">机动车维修竣工出厂合格证</div>
          <div v-if="uploadData.carFactoryCertificate" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carFactoryCertificate.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carFactoryCertificate"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(7)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carFactoryCertificate ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carFactoryCertificate &&
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carFactoryCertificate"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handlePictureCardPreview(7)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carFactoryCertificate ||
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(7)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handleRemove(7)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">车辆燃料消耗量核查表或报告</div>
          <div v-if="uploadData.carFactoryCertificate" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carFactoryCertificate.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carFactoryCertificate"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(8)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carFactoryCertificate ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carFactoryCertificate &&
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carFactoryCertificate"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handlePictureCardPreview(8)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carFactoryCertificate ||
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(8)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handleRemove(8)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">机动车安全技术检验、环保检验报告</div>
          <div v-if="uploadData.carFactoryCertificate" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carFactoryCertificate.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carFactoryCertificate"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(9)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carFactoryCertificate ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carFactoryCertificate &&
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carFactoryCertificate"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handlePictureCardPreview(9)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carFactoryCertificate ||
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(9)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handleRemove(9)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="upload_img_box">
          <div class="card_title">汽车综合性能检测报告</div>
          <div v-if="uploadData.carFactoryCertificate" class="onebox">
            <div
              class="twobox"
              v-if="uploadData.carFactoryCertificate.indexOf('.pdf') != -1"
            >
              <el-image
                class="avatar_img_pd"
                src="../../../../static/images/pdf_icon.png"
              ></el-image>
            </div>
            <el-image
              v-else
              :src="uploadData.carFactoryCertificate"
              class="avatar_img"
            />
          </div>
          <div class="onebox" v-else>
            <div class="twobox">
              <img
                class="avatar_img_pd"
                src="../../../../static/images/idCard_icon.png"
                alt=""
              />
            </div>
          </div>

          <div class="btns_box">
            <div class="img_btns" @click="getImgIndex(10)">
              <el-upload
                class="avatar-uploader_btn"
                action="http://47.101.220.89:8687/file/uploadFile"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :http-request="uploadFile"
              >
                <el-button class="img_btn">{{
                  uploadData.carFactoryCertificate ? "变更" : "上传"
                }}</el-button>
              </el-upload>
            </div>
            <el-button
              class="img_btn"
              v-if="
                uploadData.carFactoryCertificate &&
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
              "
            >
              <a
                class="img_a"
                :href="uploadData.carFactoryCertificate"
                target="_blank"
                rel="noopener noreferrer"
                >预览</a
              >
            </el-button>
            <el-button
              v-else
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handlePictureCardPreview(10)"
              >预览</el-button
            >
            <el-button
              class="img_btn"
              :disabled="
                !uploadData.carFactoryCertificate ||
                uploadData.carFactoryCertificate.indexOf('.pdf') != -1
                  ? true
                  : false
              "
              @click="downs(10)"
              >下载</el-button
            >
            <el-button
              class="img_btn"
              :disabled="!uploadData.carFactoryCertificate ? true : false"
              @click="handleRemove(10)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <v-redactPapersResid
      :dialogShow.sync="redactResidInfoShow"
    ></v-redactPapersResid>
    <v-addPapersResid
      :dialogShow.sync="addPapersResidShow"
      :carId="netId"
    ></v-addPapersResid>
    <preview-image
      :show.sync="dialogVisible"
      :name="dialogImageName"
      :url="dialogImageUrl"
    />
  </div>
</template>

<script>
import redactPapersResid from "./tabDialog/redactPapersResid.vue";
import addPapersResid from "./tabDialog/addPapersResid.vue";
import { downloadFile } from "@/utils/util";
import config from "@/utils/config";
import previewImage from "@/components/previewImage.vue";
export default {
  name: "",
  data() {
    return {
      tableData: [],
      redactResidInfoShow: false,
      addPapersResidShow: false,
      multipleSelection: [],
      imgIndex: 1,
      headers: {},
      uploadData: {},
      form: {
        carId: 0,
        image: "",
        isBase: 1,
        type: 1,
      },
      cerTypeList: [],
      imgHttp: "",
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false,
    };
  },
  components: {
    "v-redactPapersResid": redactPapersResid,
    "v-addPapersResid": addPapersResid,
    previewImage,
  },
  props: {
    netId: Number,
  },
  created() {
    this.headers = {
      Authorization: sessionStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    this.imgHttp = config.baseUrl;
  },
  methods: {
    getImgIndex(index) {
      console.log(index);
      this.imgIndex = index;
    },
    uploadFile(file) {
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$http.uploadFile(formData).then((res) => {
        switch (this.imgIndex) {
          case 1:
            this.uploadData.carDrivingLicense1 = res.msg;
            this.form = {
              carId: this.netId,
              image: this.uploadData.carDrivingLicense1,
              isBase: 1,
              type: this.imgIndex,
            };
            this.$http.updateCarCertificate(this.form).then((res) => {
              if (res.code === 0) {
                this.getList();
              }
            });
            break;
          case 2:
            this.uploadData.carDrivingLicense2 = res.msg;
            this.form = {
              carId: this.netId,
              image: this.uploadData.carDrivingLicense2,
              isBase: 1,
              type: this.imgIndex,
            };
            this.$http.updateCarCertificate(this.form).then((res) => {
              if (res.code === 0) {
                this.getList();
              }
            });
            break;
          case 3:
            this.uploadData.roadTransportCertificate1 = res.msg;
            this.form = {
              carId: this.netId,
              image: this.uploadData.roadTransportCertificate1,
              isBase: 1,
              type: this.imgIndex,
            };
            this.$http.updateCarCertificate(this.form).then((res) => {
              if (res.code === 0) {
                this.getList();
              }
            });
            break;
          case 4:
            this.uploadData.roadTransportCertificate2 = res.msg;
            this.form = {
              carId: this.netId,
              image: this.uploadData.roadTransportCertificate2,
              isBase: 1,
              type: this.imgIndex,
            };
            this.$http.updateCarCertificate(this.form).then((res) => {
              if (res.code === 0) {
                this.getList();
              }
            });
            break;
          case 5:
            this.uploadData.carRegistrationCertificate = res.msg;
            this.form = {
              carId: this.netId,
              image: this.uploadData.carRegistrationCertificate,
              isBase: 1,
              type: this.imgIndex,
            };
            this.$http.updateCarCertificate(this.form).then((res) => {
              if (res.code === 0) {
                this.getList();
              }
            });
            break;
          case 6:
            this.uploadData.carFactoryCertificate = res.msg;
            this.form = {
              carId: this.netId,
              image: this.uploadData.carFactoryCertificate,
              isBase: 1,
              type: this.imgIndex,
            };
            this.$http.updateCarCertificate(this.form).then((res) => {
              if (res.code === 0) {
                this.getList();
              }
            });
            break;
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf";
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为 且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
    getSelect() {
      this.$http.getCarCertificateSelect().then((res) => {
        if (res.code === 0) {
          this.cerTypeList = res.data;
        } else {
          this.$message.info(res.msg);
        }
      });
    },
    getList() {
      this.headers = {
        Authorization: sessionStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      };

      this.$http.getCarCertificate({ id: this.netId }).then((res) => {
        if (res.code === 0) {
          this.uploadData = res.data;
        }
      });
    },
    redactChange() {
      this.redactResidInfoShow = true;
    },
    addChange() {
      console.log(this.netId);
      this.addPapersResidShow = true;
    },
    handlePictureCardPreview(index) {
      switch (index) {
        case index:
          let url = "";
          let name = "";
          if (index === 1) {
            url = this.uploadData.carDrivingLicense1;
            name = "机动车行驶证1";
          } else if (index === 2) {
            url = this.uploadData.carDrivingLicense2;
            name = "机动车行驶证2";
          } else if (index === 3) {
            url = this.uploadData.roadTransportCertificate1;
            name = "道路运输证1";
          } else if (index === 4) {
            url = this.uploadData.roadTransportCertificate2;
            name = "道路运输证2";
          } else if (index === 5) {
            url = this.uploadData.carRegistrationCertificate;
            name = "机动车登记证书";
          } else if (index === 6) {
            url = this.uploadData.carFactoryCertificate;
            name = "机动车整车出厂合格证";
          }
          this.dialogImageUrl = url;
          this.dialogImageName = name;
          this.dialogVisible = true;
          break;
      }
    },
    handleRemove(index) {
      switch (index) {
        case 1:
          this.form = {
            carId: this.netId,
            image: "",
            isBase: 1,
            type: index,
          };
          this.$http.updateCarCertificate(this.form).then((res) => {
            if (res.code === 0) {
              this.getList();
            }
          });
          break;
      }
    },
    downs(index) {
      switch (index) {
        case index:
          let url = "";
          let name = "";
          if (index === 1) {
            url = this.uploadData.carDrivingLicense1;
            name = "机动车行驶证1";
          } else if (index === 2) {
            url = this.uploadData.carDrivingLicense2;
            name = "机动车行驶证2";
          } else if (index === 3) {
            url = this.uploadData.roadTransportCertificate1;
            name = "道路运输证1";
          } else if (index === 4) {
            url = this.uploadData.roadTransportCertificate2;
            name = "道路运输证2";
          } else if (index === 5) {
            url = this.uploadData.carRegistrationCertificate;
            name = "机动车登记证书";
          } else if (index === 6) {
            url = this.uploadData.carFactoryCertificate;
            name = "机动车整车出厂合格证";
          }
          downloadFile(this.imgHttp + url, name);
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./redact.less";
.redact_container {
  overflow-y: scroll;
}
.form_title {
  width: 100%;
  position: relative;
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  padding-left: 16px;
  box-sizing: border-box;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  >span{
    font-size: 14px;
    color: #6e6e6e;
    margin-left: 20px;
  }

  .astrict_text {
    margin-left: 10px;
    font-size: 13px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6e6e6e;
  }
}

.form_title::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 6px;
  height: 18px;
  background-color: #8eafff;
}
.addbtn {
  width: 104px;
  height: 36px;
  background: #ffffff;
  border-radius: 4px;
  border: 2px solid #255A7E;
  color: #255A7E;
  margin-left: 33px;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/redact_papers.vue